import React from "react";
import logo from "../../assets/logo.png";
import imgIcon from "../../assets/img_icon.svg";
import colorIcon from "../../assets/color_icon.svg";
import userIcon from "../../assets/user.svg";
import premiumIcon from "../../assets/premium2.svg";
import { NavLink } from "react-router-dom";

export const UserSideBar = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const role = authUser?.user?.user_type === 1 ? "user" : "artist";

  const user = [
    { path: "/user", label: "Upload Image", icon: imgIcon },
    { path: "/user/my-contests", label: "My Contests", icon: colorIcon },
    { path: `/user/profile/${authUser.userId}`, label: "Profile Details", icon: userIcon },
  ];

  const menuItems = user;

  return (
    <div className="relative w-full h-full flex flex-col items-center">
      {/* Logo */}
      <div className="flex items-center justify-center">
        <div className="w-[70px] h-[71px] ">
          <img
            src={logo}
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Navigation Part */}
      <div className="pt-7 px-7 w-full flex items-center justify-center">
        <ul className="flex flex-col">
          {menuItems.map((item) => (
            <li key={item.path} className="relative mb-[6px]">
              <NavLink
                to={item.path}
                end={item.path === "/user" || item.path === "/artist" || item.path === "/admin"}
                className={({ isActive }) =>
                  `px-[24px] py-3 flex items-center justify-start gap-2 outline-none  rounded-[10px]  ${isActive
                    ? "text-white font-bold bg-primary"
                    : "text-black hover:bg-primary hover:text-white"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span className="absolute -left-3 top-1/2 transform -translate-y-1/2 h-5 w-[3px] bg-primary rounded-r-md"></span>
                    )}
                    <img src={item.icon} alt="icon" className="w-5 h-5" />
                    <span className="font-medium text-xs font-grotesk tracking-wider">
                      {item.label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {role === "user" && (
        <div className="px-5 absolute bottom-4">
          <button className="min-w-[174px] h-[60px] px-5 py-3 bg-[#F7F7F7] border border-border_color text-secondary rounded-[10px] flex items-center gap-2">
            <img src={premiumIcon} alt="Loading" className="w-5 h-5" />
            <span className="font-bold text-xs font-grotesk text-start">
              Get Premium Version
            </span>
          </button>
        </div>
      )}
    </div>
  );
};
